import { ForwardedRef, forwardRef } from "react";

// Custom styles for MDBox
import MDBoxRoot from "./MDBoxRoot";

interface IMDBoxProps {
  variant: string,
  bgColor: string,
  color: string,
  opacity: number,
  borderRadius: string,
  shadow: string,
  coloredShadow: string,
  children: React.ReactNode,
  [rest: string]: any;
}

export const MDBox = forwardRef(
  ({ 
    variant = "contained", 
    bgColor = "transparent", 
    color = "dark", 
    opacity = 1, 
    borderRadius = "none", 
    shadow = "none", 
    coloredShadow = "none", 
    ...rest 
  }: IMDBoxProps, ref: ForwardedRef<any>) => (
    <MDBoxRoot
      {...rest}
      ref={ref}
      ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow }}
    />
  )
);
